import { buildQuery, httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'

const SUBSEQUENT_BLOCKING_TIME = 5 * 60 * 1000 // 5 min

const buildExportPath = (params, scope) => {
  const path = '/api/exports'
  const query = buildQuery(
    {
      ...params,
      scope_type: scope.type,
      scope_id: scope.id,
      type: 'scheduled_events'
    },
    { arrayFormat: 'brackets' },
  )
  return `${path}?${query}`
}

const downloadExport = (path) => window.open(path, '_self')

const clearExportTimeout = (getState) => {
  const prevTimerId = getState().scheduled_events.export.timeoutTimerId
  if (prevTimerId != null) {
    clearTimeout(prevTimerId)
  }
}

const setExportLoading = () => ({ type: 'EXPORT_EVENTS_REQUEST' })

const setExportLoadingDone = () => ({ type: 'EXPORT_EVENTS_DONE' })

const setExportError = (message) => ({
  type: 'EXPORT_EVENTS_SET_ERROR',
  payload: {
    error: message,
  },
})

const showExportConfirmation = () => ({ type: 'EXPORT_EVENTS_SHOW_CONFIRMATION' })

export const enableExporting = () => (dispatch, getState) => {
  clearExportTimeout(getState)
  dispatch({ type: 'ENABLE_EXPORT_EVENTS' })
}

const disableExporting = () => (dispatch, getState) => {
  clearExportTimeout(getState)
  const newTimerId = setTimeout((() => dispatch(enableExporting())), SUBSEQUENT_BLOCKING_TIME)
  dispatch({
    type: 'DISABLE_EXPORT_EVENTS',
    payload: {
      timerId: newTimerId,
    },
  })
}

export const exportEvents = (params, scope) => async (dispatch) => {
  dispatch(setExportLoading())
  const [success, responseData] = await httpRequest({
    url: buildExportPath(params, scope),
    method: 'POST',
  })

  dispatch(setExportLoadingDone())
  if (success) {
    dispatch(disableExporting())
    switch (responseData.location) {
      case 'email':
        dispatch(showExportConfirmation())
        break
      case 'inline':
      default:
        downloadExport(buildExportPath(params, scope))
    }
  } else {
    dispatch(setExportError(I18n.t('errors.default'))) // TODO getErrorMessage(responseData)
  }
}

export const dismissExportConfirmation = () => ({ type: 'EXPORT_EVENTS_DISMISS_CONFIRMATION' })

export const clearExportError = () => ({ type: 'EXPORT_EVENTS_CLEAR_ERROR' })
